var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-row',{attrs:{"gutter":24}},[_c('a-col',{attrs:{"span":6}},[_c('RemoteZoneLeft')],1),_c('a-col',{attrs:{"span":12}},[_c('RemoteZoneMid')],1),_c('a-col',{attrs:{"span":6}},[_c('RemoteZoneRight')],1),_c('RemoteZoneBottom')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }